var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfferOpen = function SvgOfferOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14 3h2.4c.424 0 .831.167 1.131.464s.469.7.469 1.12V8M6 3H3.6c-.424 0-.831.167-1.131.464S2 4.164 2 4.584v15.833c0 .42.169.822.469 1.12.3.296.707.463 1.131.463H9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12.4 1H7.6A1.6 1.6 0 0 0 6 2.6v.8A1.6 1.6 0 0 0 7.6 5h4.8A1.6 1.6 0 0 0 14 3.4v-.8A1.6 1.6 0 0 0 12.4 1M6 9h6M6 13h3M6 17h2M19 19l-2-1.348V15"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M11 17a6 6 0 1 0 12 0 6 6 0 0 0-12 0"
  })));
};
export default SvgOfferOpen;